import {
  collection,
  getDocs,
  orderBy,
  query,
  QueryDocumentSnapshot,
  where,
} from "firebase/firestore";
import { db } from "~/integrations/firebase/firestore";
import { FirestoreOrganisation, TrendsType } from "reedy-data/models";
import { TrendWithId } from "./trends";

export interface IProductsByTrend {
  id: string;
  organisation: FirestoreOrganisation;
  trend: TrendWithId;
  products: string[];
}

const productsByTrendConverter = {
  toFirestore(project: IProductsByTrend) {
    return project;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): IProductsByTrend {
    const documentData = {
      ...snapshot.data(),
      id: snapshot.id,
      products: snapshot.data().newProducts || [],
    };
    return documentData as IProductsByTrend;
  },
};

const getProductsByTrendCollection = () =>
  collection(db, "productsByTrend").withConverter(productsByTrendConverter);

export const getProductsByTrendForCountry = async (
  organisationId: string,
  trendsType: TrendsType,
  countryCode: string,
) => {
  const queryTrendsGoogleOrAmazon = query(
    getProductsByTrendCollection(),
    where("organisation.id", "==", organisationId),
    where("trend.trendType", "==", trendsType),
    ...(trendsType === TrendsType.GOOGLE
      ? [where("trend.region", "==", countryCode)]
      : []),
    orderBy("trend.rank", "asc"),
  );

  const snapshot = await getDocs(queryTrendsGoogleOrAmazon);
  const loadedTrends = snapshot.docs.map((document) => ({
    ...document.data(),
    id: document.id,
  })) as IProductsByTrend[];
  return loadedTrends;
};
